import api from "src/apis/api";

export async function fetchToday() {
  const { data } = await api.get("/api/v1/attendances/today");
  return data;
}

export async function markAttendance({ kind, latitude, longitude, accuracyMeters, selfieBlob }) {
  const formData = new FormData();
  formData.append("kind", kind);
  formData.append("latitude", latitude);
  formData.append("longitude", longitude);
  if (accuracyMeters != null) formData.append("accuracy_meters", accuracyMeters);
  if (selfieBlob) formData.append("selfie", selfieBlob, "selfie.jpg");

  const { data } = await api.post("/api/v1/attendances", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function fetchMyAttendances({ from, to } = {}) {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const { data } = await api.get(`/api/v1/attendances?${params}`);
  return data;
}

export async function fetchAttendanceReport({ from, to, userId, geofenceId } = {}) {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  if (userId) params.set("user_id", userId);
  if (geofenceId) params.set("geofence_id", geofenceId);
  const { data } = await api.get(`/api/v1/attendance_reports?${params}`);
  return data;
}

export function attendanceReportExportUrl({ from, to, userId, geofenceId } = {}) {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  if (userId) params.set("user_id", userId);
  if (geofenceId) params.set("geofence_id", geofenceId);
  return `/api/v1/attendance_reports/export?${params}`;
}
